import { Box, Heading, Button, Link } from "@chakra-ui/react";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useTranslation } from "react-i18next";
import { IEventDetail } from "../../model";

export const Contact = ({ data }: { data: IEventDetail }) => {
  const { t } = useTranslation();
  return (
    <Box
      w={{ base: "100%", md: "30%" }}
      textAlign={{ base: "center", md: "left" }}
    >
      <Heading
        as="h3"
        fontSize="24px"
        mb="15px"
        textAlign="center"
        // color="#6AF6FF"  // Brand color for heading
      >
        {t("Contact")}
      </Heading>
      <Box mt="20px">
        <Link href={`tel:${data?.mobileNumber}`}>
          <Button
            w="100%"
            p="15px"
            borderRadius="10px"
            backgroundColor="#ededed"
            leftIcon={<FontAwesomeIcon icon={faPhone} />}
            color="#333"
            _hover={{ backgroundColor: "#d6d6d6" }} // Slightly darker shade on hover
          >
            {data?.mobileNumber}
          </Button>
        </Link>
      </Box>
    </Box>
  );
};
